import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { makeIsFeatureEnabledSelector } from 'domain/FeatureAccess/selectors'

/**
 * useFeatureAccessControlEnabled
 *
 * React hook that returns a boolean indicating whether a given
 * feature (identified by featureCode) is enabled according to
 * the FeatureAccess Redux slice.
 *
 */
const useFeatureAccessControlEnabled = featureCode => {
  // Memoise a selector instance per feature code so that React Redux
  // can efficiently subscribe and avoid unnecessary recomputations.
  const selector = useMemo(
    () => makeIsFeatureEnabledSelector(featureCode),
    [featureCode]
  )

  return useSelector(selector)
}

export default useFeatureAccessControlEnabled
